// タグの表示色プリセット。バックエンドはトークン文字列（gray/red/... の8色）を保存し、
// UI側でここで淡い背景＋濃い文字色のTailwindクラスに解決する。
export const TAG_COLORS = [
  'gray',
  'red',
  'orange',
  'yellow',
  'green',
  'blue',
  'purple',
  'pink',
] as const;

export type TagColorToken = (typeof TAG_COLORS)[number];

type TagColorClasses = {
  bg: string;
  text: `text-${string}`;
  ring: string;
  border: string;
  // text と同じ色を使うことで、白文字とのコントラスト比が必ず 4.5:1 以上になる。
  solidBg: string;
};

// JIT がクラスを検出できるよう、すべて静的なリテラル文字列で定義する（動的生成しない）。
export const TAG_COLOR_CLASSES: Record<TagColorToken, TagColorClasses> = {
  gray: {
    bg: 'bg-[#F1F5F9]',
    text: 'text-[#334155]',
    ring: 'ring-[#CBD5E1]',
    border: 'border-[#CBD5E1]',
    solidBg: 'bg-[#334155]',
  },
  red: {
    bg: 'bg-[#FEE2E2]',
    text: 'text-[#B91C1C]',
    ring: 'ring-[#FCA5A5]',
    border: 'border-[#FCA5A5]',
    solidBg: 'bg-[#B91C1C]',
  },
  orange: {
    bg: 'bg-[#FFEDD5]',
    text: 'text-[#C2410C]',
    ring: 'ring-[#FDBA74]',
    border: 'border-[#FDBA74]',
    solidBg: 'bg-[#C2410C]',
  },
  yellow: {
    bg: 'bg-[#FEF9C3]',
    text: 'text-[#A16207]',
    ring: 'ring-[#FDE047]',
    border: 'border-[#FDE047]',
    solidBg: 'bg-[#A16207]',
  },
  green: {
    bg: 'bg-[#DCFCE7]',
    text: 'text-[#15803D]',
    ring: 'ring-[#86EFAC]',
    border: 'border-[#86EFAC]',
    solidBg: 'bg-[#15803D]',
  },
  blue: {
    bg: 'bg-[#DBEAFE]',
    text: 'text-[#1D4ED8]',
    ring: 'ring-[#93C5FD]',
    border: 'border-[#93C5FD]',
    solidBg: 'bg-[#1D4ED8]',
  },
  purple: {
    bg: 'bg-[#F3E8FF]',
    text: 'text-[#7E22CE]',
    ring: 'ring-[#D8B4FE]',
    border: 'border-[#D8B4FE]',
    solidBg: 'bg-[#7E22CE]',
  },
  pink: {
    bg: 'bg-[#FCE7F3]',
    text: 'text-[#BE185D]',
    ring: 'ring-[#F9A8D4]',
    border: 'border-[#F9A8D4]',
    solidBg: 'bg-[#BE185D]',
  },
};

// バックエンドが想定外の色トークンを返しても落ちないよう gray にフォールバックする。
export const resolveTagColorClasses = (color: string): TagColorClasses =>
  TAG_COLOR_CLASSES[color as TagColorToken] ?? TAG_COLOR_CLASSES.gray;
